import React, { Fragment } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import ProtectedRoute from "./components/ProtectedRoute";
import { routes } from "./routers/index";
import "./App.css";
import { MealMateProvider } from "./context/MealMateContext";
import useMealReminder from "./pages/UserPremiumPage/useMealReminder"; // Đường dẫn đến hook
import { Analytics } from "@vercel/analytics/react";
// Component wrapper để gọi useMealReminder
const MealReminderActivator = () => {
  useMealReminder(); // Gọi custom hook ở đây
  return null; // Component này không render gì cả
};

function App() {
  return (
    <>
      <MealMateProvider>
        {/* Đặt MealReminderActivator ở đây, nó là một component con của MealMateProvider.
          Điều này giúp đảm bảo thứ tự render và cung cấp context đúng. */}
        <MealReminderActivator />

        <Router>
          <Routes>
            {routes.map((route) => {
              const Layout = route.layout || Fragment;
              const Wrapper = route.wrapper || Fragment;

              return route.isPrivate ? (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    <ProtectedRoute
                      allowedRoles={route.allowedRoles}
                      isPremium={route.isPremium}
                    >
                      <Layout>
                        <route.page />
                      </Layout>
                    </ProtectedRoute>
                  }
                />
              ) : (
                <Route
                  key={route.path}
                  path={route.path}
                  element={
                    <Wrapper>
                      <Layout>
                        <route.page />
                      </Layout>
                    </Wrapper>
                  }
                />
              );
            })}
          </Routes>
        </Router>
      </MealMateProvider>
      <Analytics />
    </>
  );
}

export default App;
